import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component, Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { isNotNullOrUndefined } from '@contact/upgrade';

import { default as componentAjs } from './agent-booking-phone-allocated.component.ajs';

@Directive({
  selector: 'cng-agent-booking-phone-allocated-upgrade',
})
export class AgentBookingPhoneAllocatedUpgradeComponent extends UpgradeComponent {
  @Input() responseId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-agent-booking-phone-allocated',
  template: '<cng-agent-booking-phone-allocated-upgrade [responseId]="responseId$ | async"></cng-agent-booking-phone-allocated-upgrade>',
})
export class AgentBookingPhoneAllocatedComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select).pipe(isNotNullOrUndefined());

  constructor(private readonly router: AgentDesktopRouter) {}
}
